import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Sorting } from '../../user-management/_model/sorting.model';
import { Filter } from '../../user-management/_model/filter.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class FlowService {
    token = localStorage.getItem('token');

    constructor(private http: HttpClient) { }

 
    getAllFlows() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/flows`);
    }

    getFlowById(id) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/flows/${id}`);
    }

    assignGradesToFlow(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/flows/assignGrades`, body);
    }

    private _flowData = new BehaviorSubject<Object>(null);
    flowData = this._flowData.asObservable();

    setFlowData(flow) {
        this._flowData.next(flow);
    }
    getFlowData() {
        return this._flowData;
    }

    private _reload = new BehaviorSubject<Object>(null);
    reload = this._reload.asObservable();

    changeReloadFlag(flag) {
        this._reload.next(flag);
    }
    getReload() {
        return this._reload;
    }
}